/*
 *  Product Recommendations
 *    Generates recommended products via Shopify's Product Recommendations API.
 *    Creates slick carousel with generated products
 *
 *  Version:
 *    1.0.0 - 2020/07/20
 */

import { register } from './../ShopifySection';
import { fetchRelatedSection } from './../../process/pc-slate-tools';
import * as ResponsiveSizes from './../../settings/Responsive';
import { CarouselSection } from './../carousel/CarouselSection';
import { refreshThumbnails } from './../../objects/product/ProductThumbnail';

// Selectors
const SELECTOR_CONTAINER = '[data-product-recommendations]';

class ProductRecommendations extends CarouselSection {
  constructor(container) {
    super(container);

    this.fetchRecommendedProducts().catch(e => console.error(e));
  }

  async fetchRecommendedProducts() {
    let [
      limit, product_id, product_recommendations_url, section_id
    ] = this.getAttributes([
      'data-limit', 'data-product-id', 'data-recommendations-url',
      'data-section-id'
    ]);

    let data;
    try {
      data = await fetchRelatedSection({
        section_id, product_recommendations_url, product_id, limit
      });
    } catch(e) {
      console.error(e);
      this.pending = false;
      return;
    }

    // Remove section wrapper
    data = $(data).unwrap().html();

    this.container.html(data);

    this.slick = this.initCarousel(this.container);

    let self = this;
    this.slick.on('breakpoint', function(){
      self.onReInitialize();
    });
    this.onReInitialize();
  }

  optionOverrides() {
    return {
      infinite: this.container.data('infinite') === true ? true : false,
      autoplay: this.container.data('autoplay') == true,
      autoplaySpeed: (this.container.data('autoplay-speed') * 1000) || 5000,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      adaptiveHeight: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 500,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: ResponsiveSizes.small,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: ResponsiveSizes.medium,
          settings: { arrows: true, slidesToShow: 3 }
        },
        {
          breakpoint: ResponsiveSizes.large,
          settings: { slidesToShow: 4, arrows: true }
        }
      ]
    }
  }

  onReInitialize(){
    refreshThumbnails();
  }
}

register(SELECTOR_CONTAINER, ProductRecommendations);